export default __webpack_public_path__ + "static/media/3.blur.93b6884b.jpg";